import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);
//const debug = process.env.NODE_ENV !== 'production';

const modules = {};

let store = new Vuex.Store({
  state: {
    menuList: [],
    userButtonList:[],
    temId:'',
  },
  getters: {
    getTemId(state) {
      return state.temId;
    },
    getMenulist(state) {
      return state.menuList;
    },
    getuserButtonList(state) {
      return state.userButtonList;
    },
  },
  mutations: {

    SET_temId(state, flag) {
      state.temId = flag
    },
    SET_Menulist(state,flag) {
      state.menuList = flag
    },
    SET_UserButton(state,flag) {
      state.userButtonList = flag
    },

  },
  actions: {},
  modules,
  //plugins: debug ? [require('vuex/dist/logger')()] : [],
  //strict: debug
});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js